<div class="form-group">
  <label *ngIf="label">{{ label }}</label>

  <ngx-jdatepicker
    class="custom-jdate-input"
    mode="day"
    [ngModel]="value"
    (ngModelChange)="onInput($event)"
    [config]="datePickerConfig"
    [disabled]="disabled"
    [placeholder]="placeholder || '1405/1/1'"
    (open)="onPickerOpen()"
    (close)="onPickerClose()"
    (keydown)="$event.preventDefault()"
    (paste)="$event.preventDefault()"
  >
  </ngx-jdatepicker>

  <!-- Validation messages -->
  <div
    class="error-message"
    *ngIf="control?.touched && control?.hasError('required')"
  >
    فیلد {{ label }} الزامی است.
  </div>
  <div class="error-message" *ngIf="control?.hasError('backend')">
    {{ control?.getError('backend') }}
  </div>
</div>
